import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withServerErrorCode } from '@plone/volto/helpers/Utils/Utils';
import ErrorLayout from './ErrorLayout';

const ServerError: React.FC = () => (
  <ErrorLayout
    title={
      <FormattedMessage id="error.500.title" defaultMessage="Server Error" />
    }
  >
    <p className="description">
      <FormattedMessage
        id="error.500.body"
        defaultMessage="We apologize for the inconvenience, but there was an unexpected error on the server."
      />
    </p>
  </ErrorLayout>
);

export default withServerErrorCode(500)(ServerError);
